
    import I18n from 'i18nObj';
    
      import 'translations/message_students_dialog';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('message_students_dialog');
  